import Image from 'next/image';
import type { HistoryItem } from '../type';

export function SlideItem({ title, description, image, badges }: HistoryItem) {
  return (
    <div className="flex-none w-full flex flex-col @lg:flex-row @lg:items-center gap-4 @lg:gap-16">
      <div className="relative w-full @lg:w-[559px] h-[307px] @lg:h-[505px] rounded-2xl overflow-hidden @lg:shrink-0">
        {image && (
          <Image
            src={image}
            alt={title}
            fill
            className="object-cover"
            sizes="(max-width: 1024px) 100vw, 559px"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent from-[32%] to-black/30" />
      </div>

      <div className="flex-1 flex flex-col gap-2 @lg:gap-4 text-brand-text-button h-68 max-h-68 overflow-y-hidden">
        <h3 className="font-serif text-[32px] @lg:text-[44px] leading-[1.2] @lg:leading-[1.1] tracking-[-0.64px] @lg:tracking-[-0.88px]">
          {title}
        </h3>
        <p className="font-sans text-base @lg:text-xl leading-[1.5] @lg:leading-[1.3] @lg:tracking-[-0.4px]">
          {description}
        </p>
        {badges && (
          <div className="flex items-center gap-4 flex-wrap mt-2">
            {badges.map((badge, i) => (
              <Image
                key={i}
                src={badge}
                width={60}
                height={60}
                alt=""
                className="h-15 w-auto object-contain"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
